module.exports = __webpack_public_path__ + "static/media/logo.3fe6a472.png";